export default __webpack_public_path__ + "static/media/ayoub.4cd81a5b.png";